import { getStatus } from '@ms/yammer-data-support';

import { YammerState } from '../../state/types';

type IsNotRequested = (state: YammerState) => boolean;
export const isNotRequested: IsNotRequested = (state) => getStatus(state.pushSubscriptions) === 'notRequested';

type IsRegistered = (state: YammerState, subscription: PushSubscription | null | undefined) => boolean | undefined;
export const isRegistered: IsRegistered = (state, subscription) => {
  if (subscription === undefined || state.pushSubscriptions.fulfilled === undefined) {
    return undefined;
  }

  return (
    state.pushSubscriptions.fulfilled.find(
      (registeredSubscription) => subscription && registeredSubscription.endpoint === subscription.endpoint
    ) != null
  );
};
